import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=9b9cf67a&scoped=true&"
import script from "./MenuButton.vue?vue&type=script&lang=js&"
export * from "./MenuButton.vue?vue&type=script&lang=js&"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=9b9cf67a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9cf67a",
  null
  
)

export default component.exports